import {Injectable} from '@angular/core';
import {ModalService} from '../modal-service.service';
import {FieldRecordLodgementErrorModalComponent} from './field-record-lodgement-errors-modal.component';

@Injectable({
    providedIn: 'root'
})
export class FieldRecordLodgementErrorModalService extends ModalService {
    showModal(lodgementErrorList: string[], lodgementErrorText?: string) {
        this.createModalComponent(FieldRecordLodgementErrorModalComponent);
        const fieldRecordLodgementErrorModalComponent = this.modalComponentRef.instance as FieldRecordLodgementErrorModalComponent;
        fieldRecordLodgementErrorModalComponent.title = 'Lodgement errors';
        fieldRecordLodgementErrorModalComponent.lodgementErrorList = lodgementErrorList;
        fieldRecordLodgementErrorModalComponent.lodgementErrorText = lodgementErrorText ? lodgementErrorText : undefined;
        this.showModalComponent();
        return fieldRecordLodgementErrorModalComponent.modalClosed;
    }
}
